import { useTranslation } from "react-i18next";

import { IArticleImage } from "../../../../../../@types/Articles";
import {
  BodyContainer,
  CancelButton,
  Header,
  ImageCard,
  ImageLibraryContainer,
  ImagesContainer,
} from "./ImageLibrary.styles";

export interface IImageLibraryProps {
  images: IArticleImage[];
  onClose: (selectedImage?: string) => void;
}

export function ImageLibrary({ images, onClose }: IImageLibraryProps) {
  const { t } = useTranslation();

  const handleImages = () => {
    const imagesToDisplay: any[] = [];

    images.forEach((image) => {
      imagesToDisplay.push(
        <ImageCard key={image.key} onClick={() => onClose(image.key)}>
          <img src={image.preSignedUrl} alt={image.key} />
        </ImageCard>
      );
    });

    return imagesToDisplay;
  };

  return (
    <ImageLibraryContainer>
      <Header>
        <p>{t("careInfo_imageLibrary_title")}</p>
        <CancelButton onClick={() => onClose()}>
          {t("common_cancel")}
        </CancelButton>
      </Header>

      <BodyContainer>
        <ImagesContainer>{handleImages()}</ImagesContainer>
      </BodyContainer>
    </ImageLibraryContainer>
  );
}
